import './manager-pipeline-step.scss'

import {
  Box,
} from '@mui/material'
import {
  MANAGER_WORKFLOW_STEP_STATE,
} from 'config/constants'
import {
  managerStepShowsBody,
  managerWorkflowStepWaitingHintMarginTop,
} from '../manager-workflow'

const ManagerPipelineStep = ({
  step,
  selectedStepId,
  children,
  waitingHint,
}: ApplicationManagerPipelineStepProps) => {
  if (!step) {
    return null
  }

  const showBody = managerStepShowsBody(step.state)
  const waitingHintMarginTop = managerWorkflowStepWaitingHintMarginTop(showBody)

  return (
    <Box
      className='application-manager-pipeline-step'
      component='section'
      id={`application-manager-stage-${step.id}`}
      aria-labelledby={`application-manager-stage-button-${step.id}`}
      hidden={selectedStepId !== step.id}
    >
      {showBody && children}

      {step.state === MANAGER_WORKFLOW_STEP_STATE.CURRENT && waitingHint && (
        <Box sx={{
          mt: waitingHintMarginTop,
        }}>
          {waitingHint}
        </Box>
      )}
    </Box>
  )
}

export default ManagerPipelineStep
